module.exports = __webpack_public_path__ + "jtails-build/img/pattern-1.2fbb4919.svg";